<template>
  <ModalOperator ref="SetColumnsModalOperator" type="default"  title="自定义显示列项" :width="600" :customButton="true" :ghost="false" icon-type="md-settings">
    <Alert show-icon style="margin-top: 0px;margin-bottom: 0px;">请至少保留一列显示，拖动行可以调整顺序</Alert>
    <Table max-height="600" stripe border  :columns="columns1" :data="dataList" draggable @on-drag-drop="testAAA" :key="Math.random()">
      <template slot-scope="{ row, index }" slot="isShow">
          <Checkbox v-model="row.isShow" @on-change="changeIsShow(row.isShow,index)"/>
      </template>
      <template slot-scope="{ row, index }" slot="index">
        <Icon type="md-menu" title="拖动调整顺序"/>
      </template>
    </Table>
    <Button slot="customBtn" icon="md-close"  @click="closeStore">取 消</Button>
    <Button slot="customBtn" icon="md-checkmark" type="primary" @click="saveStore()">确 定</Button>
    <Button slot="customBtn" @click="allCheck" style="float: left;" icon="md-done-all">全 选</Button>
    <Button slot="customBtn" @click="revCheck" style="float: left;" icon="ios-undo">反 选</Button>
    <Button slot="customBtn" @click="reInit" style="float: left;" icon="md-refresh">恢复默认</Button>
  </ModalOperator>
</template>

<script>
import ModalOperatorMixin from '@/components/commons/ModalOperatorMixin'

export default {
  name: 'ViewLogOperator',
  mixins: [
    ModalOperatorMixin,
  ],
  components: {},
  props: {
    menuCode: {type: String, default: ''},
    columns: {type: Array, default: () => []}
  },
  data() {
    return {
      columns1: [
        {
          title: '显示',
          key: 'isShow',
          slot: 'isShow',
          align: 'center',
          width: 80,
        },
        {
          title: '列名',
          key: 'title'
        },
        {
          // type: 'index',
          title: '拖动调整顺序',
          align: 'center',
          width: 110,
          slot: 'index',
        }
      ],
      dataList: []
    }
  },
  methods: {
    testAAA(n, o) {
      const temp = this.dataList[n]
      this.dataList[n] = this.dataList[o]
      this.dataList[o] = temp
      this.dataList.splice(0, 0)
    },
    async beforeOpen() {
      // 获得 历史数据
      let str = localStorage.getItem(this.menuCode)
      if (str) {
        this.dataList = JSON.parse(str)
      } else {
        let arr = JSON.parse(JSON.stringify(this.columns))
        arr.forEach(p => {
          p.isShow = true
        })
        this.dataList = arr
      }
    },
    changeIsShow(flag, index) {
      this.$set(this.dataList[index], 'isShow', flag)
    },
    allCheck() {
      this.dataList.forEach(p => {
        p.isShow = true
      })
    },
    revCheck() {
      this.dataList.forEach(p => {
        p.isShow = !p.isShow
      })
    },
    reInit() {
      let arr = JSON.parse(JSON.stringify(this.columns))
      arr.forEach(p => {
        p.isShow = true
      })
      this.dataList = arr
    },
    saveStore() {
      if (!this.dataList.some(p => p.isShow)) {
        this.$Message.warning('请至少显示一列')
        return
      }
      localStorage.setItem(this.menuCode, JSON.stringify(this.dataList))
      this.handleSpinCustom()
      location.reload()
    },
    handleSpinCustom () {
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', '配置中，请稍等')
          ])
        }
      });
    },
    closeStore() {
      this.$refs.SetColumnsModalOperator.close()
    }
  },
}
</script>
<style scoped>

</style>
